import { ChartConfig } from 'components/Chart';

export const superDispatchPriceTrendChartConfig: ChartConfig = {
  price: {
    label: 'Price',
    color: '#f98600', // tailwind config orange-main
  },
};
